(function () {
  'use strict';

  angular.module('app').component('accountDetail', accountDetail());

  function accountDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
      },
      controller: AccountDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/admin/accounts/account-detail/account-detail.component.html',
    };
  }

  AccountDetailCtrl.$inject = [
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'AccountService',
    'PlanService',
    'FeatureService',
    'AddonService',

    // Angular downgraded service
    'countryService',
    'currencyService',
    'userModalService',
  ];

  function AccountDetailCtrl(
    config,
    $translate,
    $filter,
    UtilService,
    AccountService,
    PlanService,
    FeatureService,
    AddonService,

    // Angular downgraded service
    countryService,
    currencyService,
    userModalService
  ) {
    const vm = this;

    vm.UtilService = new UtilService(vm);

    $translate = $filter('translate');

    vm.currentStep = vm.currentStep || 1;

    let cropedImage = { file: null };

    vm.dateDisplay = config.DATE_DISPLAY;
    vm.activeStatus = config.ACTIVE;

    vm.timeZoneOptions = vm.UtilService.groupTimeZonesByValue(config.TIME_ZONES);

    vm.selectedAccounPlanFeature = {};

    vm.cardPlaceholders = {
      name: $translate('YOUR_FULL_NAME'),
      number: 'xxxx xxxx xxxx xxxx',
      expiry: 'MM/YY',
      cvc: 'xxx',
    };

    vm.cardMessages = {
      validDate: 'valid\nthru',
      monthYear: 'MM/YYYY',
    };

    vm.cardOptions = {
      debug: false,
      formatting: true,
    };

    vm.accountPlanAddons = [];

    // Methods
    vm.selectCountry = selectCountry;
    vm.selectTaxIdType = selectTaxIdType;
    vm.selectState = selectState;
    vm.selectCity = selectCity;
    vm.selectCountryPhone = selectCountryPhone;
    vm.selectCountryFax = selectCountryFax;

    vm.selectPlan = selectPlan;
    vm.goStep = goStep;
    vm.openUserInfoModal = openUserInfoModal;
    vm.openPlanInfoModal = openPlanInfoModal;

    vm.groupPlanAddonsByFeature = groupPlanAddonsByFeature;
    vm.addPlanAddon = addPlanAddon;
    vm.removePlanAddon = removePlanAddon;
    vm.selectPlanAddon = selectPlanAddon;
    vm.changePlanAddonStatus = changePlanAddonStatus;

    vm.editAccount = editAccount;
    vm.cancelEdit = cancelEdit;
    vm.createAccount = createAccount;
    vm.updateAccountDetails = updateAccountDetails;
    vm.updateAccountPlanDetails = updateAccountPlanDetails;
    vm.updateAccountBillingDetails = updateAccountBillingDetails;
    vm.cancel = cancel;
    vm.openLogo = openLogo;

    vm.setAvailableActivityCodes = setAvailableActivityCodes;

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        setItemOptions(vm.item, vm.mode);
        getTaxIdTypesByCountry(vm.item.company.country);
        getActivityCodesByCountry(vm.item.company.country);
      } else {
        // New
        vm.createMode = true;

        vm.originalItem = {
          subdomain: '',
          user: {
            username: '',
          },
        };

        vm.item = {
          auto_renew_subscription: false,
          company: {},
          user: {},
          // remove from here
          /*account_name:       'Grupo Aventuras S.A.',
                    legal_id:         '12345',
                    commercial_name:  'Aventuras CR',
                    main_phone:       '2479 0011',
                    secondary_phone:  '2479 0022',
                    fax_number:       '2479 0033',
                    address_state:    'Alajuela',
                    address_city:     'La Fortuna',
                    address_zip:      '12345',
                    address:          '100 mts north from the Catholic church',
                    website:          'www.aventurascr.com',
                    subdomain:        'aventurascr',
                    bank_name:             'National Bank CR',
                    bank_account_number:    '200-01-0123123-0123',
                    bank_account_client_id: '1234567890',
                    ccard_number:     '4444444444444444',
                    ccard_person:     'Willy Rios',
                    ccard_expiration: '12/2020',
                    ccard_cvc:        '123',
                    user: {
                        first_name:           'Carlos',
                        last_name:            'Rojas',
                        email:                'carlos@aventurascr.com',
                        username:             'aventurascr',
                        password:             'Asd123$',
                        passwordConfirmation: 'Asd123$'
                    }*/
        };

        vm.itemName = 'NEW_ACCOUNT';
        vm.labelAddLogo = 'ADD_PHOTO';

        // Initializers
        getCountries();
        getCurrencies();
      }

      // Initializers
      getPlans();
    };

    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        editAccount();
      }

      vm.countrySelected = item.company.country;
      if (vm.countrySelected) {
        setCountryStatesLabels(vm.countrySelected);
      }

      selectPlan(item.plan);

      vm.currentPlan = angular.copy(item.plan);
      // vm.currentPlanFeatures        = angular.copy(item.plan.plan_features);
      // vm.currentAccountPlanFeatures = angular.copy(item.account_plan_features);

      vm.flashMessage = vm.UtilService._displayFlashMessage();

      vm.itemName = item.account_name;
      vm.saveButtonLabel = 'UPDATE_ACCOUNT_DETAILS';
      vm.labelAddLogo = item.logo.url ? 'CHANGE_PHOTO' : 'ADD_PHOTO';

      vm.originalItem = angular.copy(item);
    }

    function editAccount() {
      vm.createMode = false;
      vm.editMode = true;
      vm.viewMode = false;

      // Initializers
      getCountries();
      setCountryStatesLabels(vm.item.company.country);
      getCountryStates(vm.item.company.country);
    }

    function cancelEdit() {
      // If we cancel the edition when changing country
      if (vm.originalItem.company.country_id !== vm.item.company.country_id) {
        getTaxIdTypesByCountry(vm.originalItem.company.country);
        getActivityCodesByCountry(vm.originalItem.company.country);
      }

      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    }

    // Initializers

    function getPlans() {
      vm.loadingPlans = true;
      PlanService.getPlans({ get: 'active', skip_check_role: true }).then(function (data) {
        vm.plans = data.items;

        if (vm.item.id) {
          // Edit
          setAccountPlanAddons(vm.item.account_plan_addons, vm.activePlanAddons);
        }

        vm.loadingPlans = false;
      });
    }

    function getCountries() {
      if (vm.countries) {
        return;
      }

      var params = {
        get: 'all',
        mdb: true,
        skip_check_role: true,
      };

      vm.loadingCountries = true;
      countryService.getCountries(params).subscribe((response) => {
        vm.countries = response;

        vm.activeCountries = vm.countries.filter(function (country) {
          return country.status === vm.activeStatus;
        });

        if (!vm.createMode) {
          if (vm.item.company.phone_code) {
            var countryPhone = vm.UtilService.findItemInArray(
              vm.countries,
              'phone_code',
              vm.item.company.phone_code
            );

            selectCountryPhone(countryPhone);
          }
        }

        vm.loadingCountries = false;
      });
    }

    function getStatesByCountry() {
      var params = {
        get: 'active',
        mdb: true,
        skip_check_role: true,
      };

      countryService.getStates(vm.item.company.country_id, params).subscribe((response) => {
        vm.statesByCountry = response;
      });
    }

    function getCitiesByState(state_id) {
      var params = {
        get: 'active',
        mdb: true,
        by_state: state_id,
        skip_check_role: true,
      };

      countryService.getCities(vm.item.company.country_id, params).subscribe((response) => {
        vm.citiesByState = response;
      });
    }

    function getDistrictsByCity(city_id) {
      var params = {
        get: 'active',
        mdb: true,
        by_city: city_id,
        skip_check_role: true,
      };

      countryService.getDistricts(vm.item.company.country_id, params).subscribe((response) => {
        vm.districtsByCity = response;
      });
    }

    function getCurrencies() {
      if (vm.currencies) return;

      var params = {
        get: 'active',
        mdb: true,
        skip_check_role: true,
      };

      vm.loadingCurrencies = true;
      currencyService.getCurrencies(params).subscribe((response) => {
        vm.currencies = response;

        // console.log(vm.currencies);

        /*if (!vm.createMode) {
                    vm.companyBaseCurrencyId = vm.currencies.find((currency) => );
                }*/

        vm.loadingCurrencies = false;
      });
    }

    // Form methods

    function selectCountry(country) {
      if (vm.countrySelected && vm.countrySelected.id === country.id) {
        // Same country is selected
        return;
      }

      vm.countrySelected = country;

      delete vm.item.company.tax_id_code;
      // vm.item.company.tax_id_code   = null;
      vm.item.company.tax_id_number = null;

      delete vm.item.company.state_id;
      delete vm.item.company.city_id;
      delete vm.item.company.district_id;
      // vm.item.company.state_id    = null;
      // vm.item.company.city_id     = null;
      // vm.item.company.district_id = null;

      vm.taxIdType = null;

      if (!vm.item.company.phone_number) {
        selectCountryPhone(country);
        vm.item.company.phone_code = country.phone_code;
      }

      getTaxIdTypesByCountry(country);
      getActivityCodesByCountry(country);
      setCountryStatesLabels(country);
      getCountryStates(country);
    }

    function selectTaxIdType(taxIdType) {
      vm.item.company.tax_id_number = null;

      vm.taxIdType = taxIdType;
    }

    function selectState(state_id) {
      vm.item.city_id = null;
      vm.item.district_id = null;
      getCitiesByState(state_id);
    }

    function selectCity(city_id) {
      vm.item.district_id = null;
      getDistrictsByCity(city_id);
    }

    function selectCountryPhone(country) {
      vm.countryPhoneSelected = country;
    }

    function selectCountryFax(country) {
      vm.countryFaxSelected = country;
    }

    function setCountryStatesLabels(country) {
      vm.stateLabel = 'STATE';
      vm.cityLabel = 'CITY';
      if (country.enable_states) {
        vm.stateLabel = 'PROVINCE';
        vm.cityLabel = 'CANTON';
      }
    }

    function getCountryStates(country) {
      if (country.enable_states) {
        getStatesByCountry();
        if (vm.item.company.state_id) {
          getCitiesByState(vm.item.company.state_id);
        }

        if (vm.item.company.city_id) {
          getDistrictsByCity(vm.item.company.city_id);
        }
      }
    }

    function getTaxIdTypesByCountry(country) {
      // TODO: what about the rest of the countries?
      if (country.code !== 'CR') {
        return;
      }

      var params = {
        country_code: country.code.toLowerCase(),
        skip_check_role: true,
      };

      vm.loadingTaxIdTypes = true;
      countryService.getTaxIdTypesByCountry(params).subscribe((response) => {
        vm.taxIdTypesByCountry = response;

        if (vm.viewMode) {
          vm.taxIdType = vm.UtilService.findItemInArray(
            response,
            'code',
            vm.item.company.tax_id_code
          );
        }

        vm.loadingTaxIdTypes = false;
      });
    }

    function getActivityCodesByCountry(country) {
      // TODO: what about the rest of the countries?
      if (country.code !== 'CR') {
        return;
      }

      var params = {
        country_code: country.code.toLowerCase(),
        skip_check_role: true,
      };

      vm.loadingActivityCodes = true;
      countryService.getActivityCodesByCountry(params).subscribe((response) => {
        vm.activityCodesByCountry = response;

        // vm.taxIdType = vm.UtilService.findItemInArray(response, 'code', vm.item.tax_id_code);
        if (!vm.createMode) {
          setAvailableActivityCodes();
        }

        vm.loadingActivityCodes = false;
      });
    }

    function goStep(step) {
      vm.UtilService.scrollToTop();
      vm.active = step;
    }

    function openUserInfoModal(item) {
      userModalService.openUserInfoModal(item);
    }

    function getUser(item) {
      vm.item.user = item;
    }

    function openPlanInfoModal(plan) {
      plan.planFeatureOptions = PlanService.groupPlanFeaturesByCategory(plan.plan_features);

      var planAddons = [];
      plan.plan_addons.forEach(function (planAddon) {
        if (planAddon.status) {
          // only active items
          planAddons.push(planAddon);
        }
      });

      // plan.planAddons = planAddons.length ? planAddons : 0;

      PlanService.openPlanInfoModal(plan);
    }

    function selectPlan(plan) {
      vm.selectedPlan = true;

      vm.planFeatureOptions = PlanService.groupPlanFeaturesByCategory(plan.plan_features);

      vm.activePlanAddons = [];
      plan.plan_addons.forEach(function (planAddon) {
        // only active plan addons and active addons
        if (planAddon.status && planAddon.addon.status === 'active') {
          vm.activePlanAddons.push(planAddon);
        }
      });

      // View
      if (!vm.createMode) {
        vm.isChangingPlan = false;
        // Selecting other plan or empty account plan features
        if (vm.item.plan_id !== plan.id || vm.item.account_plan_features.length === 0) {
          // vm.currentPlanFeatureOptions = PlanService.groupPlanFeaturesByCategory(vm.currentPlanFeatures);
          // vm.currentAccounPlanFeature  = setAccountPlanFeatures(vm.currentAccountPlanFeatures);

          vm.isChangingPlan = true;
        } else {
          vm.selectedAccounPlanFeature = setAccountPlanFeatures(vm.item.account_plan_features);
          resetPlanFeatureOptionsValueInput(vm.planFeatureOptions);
        }
      }
    }

    function groupPlanAddonsByFeature(item) {
      /*if (item.id){
                return item.feature.name;
            }*/
    }

    function addPlanAddon() {
      vm.accountPlanAddons.push({ new: true, status: true });
      validateUniqueAccounPlanAddons();
    }

    function removePlanAddon(index) {
      vm.accountPlanAddons.splice(index, 1);
      validateUniqueAccounPlanAddons();
    }

    function selectPlanAddon(plan_addon, item) {
      plan_addon.name = item.addon.name;
      plan_addon.total_units = item.total_units;
      plan_addon.unit_price = item.unit_price;
      plan_addon.status = true;

      plan_addon.plan_addon_id = item.id;

      validateUniqueAccounPlanAddons();
    }

    // Avoid duplicate account plan addons
    function validateUniqueAccounPlanAddons() {
      vm.accountPlanAddonsDuplicated = vm.UtilService.validateUniqueItems(
        vm.accountPlanAddons,
        'plan_addon_id'
      );
    }

    function changePlanAddonStatus(plan_addon) {
      plan_addon.status = !plan_addon.status;
    }

    // Append only the new plan feature not found in account plan features
    function resetPlanFeatureOptionsValueInput(planFeatureOptions) {
      for (var key in planFeatureOptions) {
        if (planFeatureOptions.hasOwnProperty(key)) {
          var planFeatures = planFeatureOptions[key].features;

          planFeatures.forEach(function (planFeature) {
            var value = (planFeature.value = planFeature.type === 'quantity' ? 1 : false);

            if (vm.selectedAccounPlanFeature[planFeature.id] === undefined) {
              vm.selectedAccounPlanFeature[planFeature.id] = { value: value };
            }
          });
        }
      }
    }

    // New or current account plan
    function setAccountPlanFeatures(accountPlanFeatures) {
      var selectedAccounPlanFeature = {};
      accountPlanFeatures.forEach(function (accountPlanFeature) {
        var type, value;

        if (accountPlanFeature.total_units != null) {
          type = 'quantity';
          value = accountPlanFeature.total_units;
        } else {
          type = 'available';
          value = accountPlanFeature.available;
        }

        var option = {
          id: accountPlanFeature.id,
          type: type,
          value: value,
          plan_feature_id: accountPlanFeature.plan_feature_id,
        };

        selectedAccounPlanFeature[accountPlanFeature.plan_feature_id] = option;
      });

      return selectedAccounPlanFeature;
    }

    function setAccountPlanAddons(accountPlanAddons, planAddons) {
      vm.accountPlanAddons = [];

      var appendToPlanAddons = function (accountPlanAddon) {
        vm.accountPlanAddons.push({
          id: accountPlanAddon.id,
          name: accountPlanAddon.plan_addon.addon.name,
          total_units: accountPlanAddon.total_units,
          unit_price: accountPlanAddon.unit_price,
          status: accountPlanAddon.status,
          plan_addon_id: accountPlanAddon.plan_addon_id,
        });
      };

      if (planAddons.length > 0) {
        accountPlanAddons.forEach(function (accountPlanAddon) {
          for (var i = 0; i < planAddons.length; i++) {
            var planAddon = planAddons[i];

            if (accountPlanAddon.plan_addon_id === planAddon.id) {
              // Plan addon exists # id # addon_id
              appendToPlanAddons(accountPlanAddon);
              break;
            }
          }
        });
      } else {
        accountPlanAddons.forEach(function (accountPlanAddon) {
          appendToPlanAddons(accountPlanAddon);
        });
      }

      vm.originalSelectedAccountPlanAddons = angular.copy(vm.accountPlanAddons);
    }

    function openLogo() {
      let logoSaved = (cropedImageObj) => {
        cropedImage = cropedImageObj;

        if (vm.editMode) {
          var account = {
            id: vm.item.id,
          };

          AccountService.updateLogo(account, cropedImage);
        } else {
          var img = document.getElementById('logo-image-preview'); // <HTMLInputElement>
          img.src = URL.createObjectURL(cropedImage.file);
        }
      };

      AccountService.openLogo(vm.item, logoSaved);
    }

    // Create
    function createAccount(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop();

        return;
      }

      var option = 'create';
      var planFeaturesSelected = FeatureService.setFeaturesSelected(
        option,
        vm.planFeatureOptions,
        'plan_feature_id',
        vm.selectedAccounPlanFeature
      );
      var planAddonsSelected = AddonService.setAddonsSelected(
        vm.accountPlanAddons,
        'plan_addon_id'
      );

      var account = {
        account_name: vm.item.account_name,
        subdomain: vm.item.subdomain,
        country_id: vm.item.company.country_id,
        country_code: vm.countrySelected.code,
        plan_id: vm.item.plan.id,
        plan_pricing: vm.item.plan_pricing,
        account_plan_features: planFeaturesSelected,
        account_plan_addons: planAddonsSelected,
        auto_renew_subscription: vm.item.auto_renew_subscription,
        bank_name: vm.item.bank_name,
        bank_account_number: vm.item.bank_account_number,
        bank_account_client_id: vm.item.bank_account_client_id,
        ccard_number: vm.item.ccard_number,
        ccard_person: vm.item.ccard_person,
        ccard_expiration: vm.item.ccard_expiration,
        ccard_cvc: vm.item.ccard_cvc,
      };

      vm.item.company.company_name = vm.item.account_name;

      delete vm.item.company.time_zone.$$hashKey;

      vm.item.user.phone = vm.item.company.phone_number;
      vm.item.user.country_id = vm.item.company.country_id;

      var params = {
        account: account,
        company: vm.item.company,
        user: vm.item.user,
      };

      // console.log(params); return;

      saveAccount(params, cropedImage);
    }

    function updateAccountDetails(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;
        vm.UtilService.scrollToTop();
      } else {
        var account = {
          id: vm.item.id,
          account_name: vm.item.account_name,
          subdomain: vm.item.subdomain,
          country_id: vm.item.company.country_id,
        };

        vm.item.company.company_name = vm.item.account_name;

        removeParamsCompanyRelations();

        var params = {
          account: account,
          company: vm.item.company,
          user: vm.item.user,
        };

        // console.log(params); return;

        saveAccount(params, {});
      }
    }

    // Remove company relations sent in json
    function removeParamsCompanyRelations() {
      delete vm.item.users;
      delete vm.item.websites;
    }

    function updateAccountPlanDetails(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;
        vm.UtilService.scrollToTop();

        return;
      }

      var option = !vm.editMode || vm.isChangingPlan ? 'create' : 'edit';
      var planFeaturesSelected = FeatureService.setFeaturesSelected(
        option,
        vm.planFeatureOptions,
        'plan_feature_id',
        vm.selectedAccounPlanFeature
      );
      var planAddonsSelected = AddonService.setAddonsSelected(
        vm.accountPlanAddons,
        'plan_addon_id'
      );

      // Remove account plan addons if unselected from original
      removeAccountPlanAddons(planAddonsSelected);

      var account = {
        id: vm.item.id,
        plan_id: vm.item.plan.id,
        plan_pricing: vm.item.plan_pricing,
        account_plan_features: planFeaturesSelected,
        account_plan_addons: planAddonsSelected,
        auto_renew_subscription: vm.item.auto_renew_subscription,
      };

      var params = {
        account: account,
      };

      // console.log(params); return;

      saveAccount(params, {});
    }

    function updateAccountBillingDetails(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;
        vm.UtilService.scrollToTop();

        return;
      }

      var account = {
        id: vm.item.id,
        bank_name: vm.item.bank_name,
        bank_account_number: vm.item.bank_account_number,
        bank_account_client_id: vm.item.bank_account_client_id,
        ccard_number: vm.item.ccard_number,
        ccard_person: vm.item.ccard_person,
        ccard_expiration: vm.item.ccard_expiration,
        ccard_cvc: vm.item.ccard_cvc,
      };

      var params = {
        account: account,
      };

      saveAccount(params, {});
    }

    function removeAccountPlanAddons(planAddonsSelected) {
      // Loop original account plan addons
      vm.originalSelectedAccountPlanAddons.forEach(function (accountPlanAddon) {
        var accountPlanAddonFound = false;
        for (var i = 0; i < planAddonsSelected.length; i++) {
          var accountPlanAddonId = planAddonsSelected[i].id;

          if (accountPlanAddon.id === accountPlanAddonId) {
            accountPlanAddonFound = true;
            break;
          }
        }

        // Remove unselected and accountPlanAddons
        if (accountPlanAddonFound === false) {
          AccountService.removeAccountPlanAddon(vm.item.id, accountPlanAddon.id);
        }
      });
    }

    function saveAccount(params, cropedImage) {
      vm.sendingForm = true;

      AccountService.saveAccount(params, cropedImage).then(
        function (response) {
          let data = response.data;

          if (!vm.editMode) {
            // create
            vm.onSavedItem({ item: data });
          } else {
            // edit
            vm.item = data; // reload item

            setItemOptions(data);

            setAccountPlanAddons(data.account_plan_addons, vm.activePlanAddons);

            vm.isChangingPlan = false;
            vm.selectedAccounPlanFeature = setAccountPlanFeatures(data.account_plan_features);

            vm.originalSelectedAccountPlanAddons = angular.copy(data.account_plan_addons);

            vm.flashMessage = vm.UtilService._clearFlashMessage();

            vm.UtilService.scrollToTop();
          }

          vm.sendingForm = false;
        },
        function (response) {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.data.errors);

          vm.formErrors = true;
          vm.UtilService.scrollToTop();

          vm.sendingForm = false;
        }
      );
    }

    function cancel() {
      vm.onCanceledItem();
    }

    function setAvailableActivityCodes() {
      vm.activityCodesPerCompany = [];
      vm.loadingActivityCodesPerCompany = true;

      for (var j = 0; j < vm.activityCodesByCountry.length; j++) {
        var activityCode = vm.activityCodesByCountry[j];

        var found = vm.item.company.company_activity_code_ids.filter(
          (id) => id === activityCode.id
        )[0]
          ? true
          : false;

        if (found) {
          if (activityCode.id === vm.item.company.company_activity_code_id) {
            vm.mainActivityCode = activityCode;
          }

          vm.activityCodesPerCompany.push(activityCode);
        }
      }

      vm.loadingActivityCodesPerCompany = false;
    }
  }
})();
